export function formatSupportMraidTag(formatName: FormatName) {
  return (
    [
      'MRAID'
      // 'Banner'
    ].indexOf(String(formatName)) !== -1
  );
}

export function isEventTypeAlwaysEnable(eventType?: string): boolean {
  if (!eventType) return false;

  const alwaysEnableTypes = [
    'android_edge_issue',
    'video_file_too_large',
    'end_screen_', // starting with
    'store_kit_', // starting with
    'ad_manager_click_url_invalid'
  ];
  return alwaysEnableTypes.some(
    type => type === eventType || eventType.indexOf(type) > -1
  );
}

export function getCreativeType(formatName: FormatName, creativeConf: any) {
  switch (formatName) {
    case 'Recommendation':
      return creativeConf.smartphonePortrait &&
        creativeConf.tabletPortrait &&
        creativeConf.tabletLandscape
        ? 'image'
        : 'url';
    case 'Recommendation Banner':
      if (creativeConf.mraid) {
        return 'mraid';
      } else if (creativeConf.html) {
        return 'url';
      } else {
        return 'image';
      }
    case 'Banner':
      if (creativeConf.image) {
        return 'image';
      } else if (creativeConf.tag) {
        return 'mraid';
      }
    default:
      return '';
  }
}

export function getFormatParams(
  formatConfig: FormatConfig,
  format: FormatName,
  redirectUrl: string
): Object {
  // commons params to track
  let params: any = {};
  switch (format) {
    case 'Banner':
      params = {
        browser: formatConfig.browser?.value,
        interaction: formatConfig.interaction,
        creative_size: formatConfig.size,
        use_icon: formatConfig.icon.useIcon,
        close_btn_size: formatConfig.closeBtn?.size,
        close_btn_display_after: formatConfig.closeBtn?.displayAfter
      };
      break;
    case 'Browser':
      params = {
        browser_keep_alive: formatConfig.keepAlive,
        content_discovery:
          formatConfig.contentDiscovery.useContentDiscovery &&
          formatConfig.contentDiscovery.hasImage,
        recommended_links:
          !formatConfig.contentDiscovery.useContentDiscovery &&
          formatConfig.recommendedLinks.useRecommendedLinks &&
          formatConfig.recommendedLinks.hasImage,
        recommended_urls: formatConfig.alternativeUrls.urls.length !== 0,
        recommended_urls_timeout: formatConfig.alternativeUrls.timeout
      };
      break;
    case 'MRAID':
      params = {
        browser: formatConfig.browser,
        use_icon: formatConfig.icon.useIcon
      };
      break;
    case 'Recommendation':
      params = {
        browser: formatConfig.browser?.type,
        interaction: formatConfig.interaction,
        close_btn_size: formatConfig.closeBtn?.iconSize,
        close_btn_display_after: formatConfig.closeBtn?.displayAfter,
        confirm_button_show: formatConfig.confirmButton.show,
        use_icon: formatConfig.icon.useIcon,
        ignore_clicks_before: formatConfig.ignoreClicksBefore,
        percent_show: formatConfig.discover.show
      };
      break;
    case 'Video':
      params = {
        browser: formatConfig.browser?.type,
        interaction: formatConfig.interaction,
        close_btn_size: formatConfig.closeBtn && formatConfig.closeBtn.size,
        close_btn_display_after:
          formatConfig.closeBtn && formatConfig.closeBtn.displayAfter,
        skin_top: Boolean(formatConfig.skin?.skinTop),
        skin_bottom: Boolean(formatConfig.skin?.skinBottom),
        skin_end_screen_image: Boolean(formatConfig.skin?.endScreenImage),
        skin_end_screen_html: Boolean(formatConfig.skin?.endScreenHtml),
        sound_on_start: formatConfig.video?.soundOnStart,
        display_sound_button: formatConfig.controls?.sound?.enabled,
        video_close_delay:
          formatConfig.closeBtn && formatConfig.closeBtn.closeDelay,
        skip_or_continue_after_delay_display:
          formatConfig.skipAfterDelay && formatConfig.skipAfterDelay.enabled,
        skip_or_continue_after_delay_delay:
          formatConfig.skipAfterDelay && formatConfig.skipAfterDelay.delay,
        on_skip_confirmation_display:
          formatConfig.confirmSkip && formatConfig.confirmSkip.enabled
      };

      break;
    case 'Recommendation Banner':
      params = {
        browser: formatConfig.browser?.value,
        interaction: formatConfig.interaction,
        size: formatConfig.size,
        icon: Boolean(formatConfig.icon.url),
        header_show: formatConfig.header.show,
        close_btn_display_after: formatConfig.closeBtn?.displayAfter
      };
      break;
    case 'Recommended Links':
      params = {
        recommended_links_acd: formatConfig.recommendedLinks.autoCloseDuration
      };
      break;
    case 'Content Discovery':
      params = {
        content_discovery_acd: formatConfig.contentDiscovery.autoCloseDuration
      };
      break;
    default:
      break;
  }
  params.redirect_url = redirectUrl;
  return params;
}
